const mutations = {
  getPartners: (state, partners) => {
    state.partners = partners;
  },
  getPartner: (state, partner_id) => {
    state.partner_id = partner_id;
  },
  getRefferalPartners: (state, refferalpartner) => {
    state.refferalpartner = refferalpartner;
  },
  getCorporatePartners: (state, corporatepartner) => {
    state.corporatepartner = corporatepartner;
  },
  getRefferalPartner: (state, refferalpartner_id) => {
    state.refferalpartner_id = refferalpartner_id;
  },
  postRefferalPartner: (state, new_refferalpartner) => {
    state.refferalpartner.push(new_refferalpartner);
  },
  putRefferalPartner: (state, payload) => {
    state.refferalpartner = state.refferalpartner.map((refferalpartner) => {
      if (refferalpartner.refferalpartner_id === payload.id) {
        return Object.assign({}, refferalpartner, payload.refferalpartnerData);
      }
      return refferalpartner;
    });
  },
  delRefferalPartner(state, id) {
    const index = state.refferalpartner.findIndex(refferalpartner => refferalpartner.refferalpartner_id == id);
    state.refferalpartner.splice(index, 1);
  },
};

export default mutations;
